<template>
    <component
        v-if="existeDatos"
        :is="componenteGrafica(tipo)"
        :labels="datos_grafica.labels"
        :dataset="datos_grafica.dataset"
        :opciones="datos_grafica.opciones"
    >
    </component>
</template>

<script>
import GrafLineal from "@components/graficas/GraficaLineal";
import GrafCircular from "@components/graficas/GraficaCircular";
import GrafApilado from "@components/graficas/GraficaApilado";
import GrafMapa from "@components/graficas/GraficaMapa";
import GrafVertical from "@components/graficas/GraficaVertical";
import GrafValor from "@components/graficas/GraficaValor";

export default {
    name: "MostrarGrafica",
    props: ["tipo", "datos_grafica"],
    components: {
        GrafLineal,
        GrafCircular,
        GrafApilado,
        GrafMapa,
        GrafVertical,
        GrafValor,
    },

    computed: {
        existeDatos() {
            return this.datos_grafica && this.datos_grafica.length !== 0;
        },
    },
    methods: {
        componenteGrafica(tipo) {
            switch (tipo) {
                case "lineal":
                    return "GrafLineal";
                case "circular":
                    return "GrafCircular";
                case "apilado":
                    return "GrafApilado";
                case "mapa_interactivo":
                    return "GrafMapa";
                case "vertical":
                    return "GrafVertical";
                case "valor":
                    return "GrafValor";
            }
        },
    },
};
</script>
